import { render, staticRenderFns } from "./PayeeInfoView.vue?vue&type=template&id=383a1f32&scoped=true&"
import script from "./PayeeInfoView.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoView.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoView.vue?vue&type=style&index=0&id=383a1f32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a1f32",
  null
  
)

export default component.exports